import { Col, Row, Text } from '@/components';
import type { FC, ReactNode } from 'react';
import { AccountAvatar } from './AccountAvatar';

type Props = {
  iconUrl?: ReactNode;
  organizationName?: string;
  accountName: string;
  maxWidth?: number;
};
export const AccountInfo: FC<Props> = ({
  iconUrl,
  organizationName,
  accountName,
  maxWidth = 300,
}) => {
  return (
    <Row gutter={[8, 0]} align="top" wrap={false}>
      <Col flex="none" style={{ paddingTop: 4 }}>
        <AccountAvatar iconUrl={iconUrl} />
      </Col>
      <Col flex="auto">
        <Row gutter={[0, 2]}>
          {organizationName && (
            <Col span={24}>
              <Text
                variant="footnote"
                color="secondary"
                maxWidth={maxWidth}
                maxRows={1}
                style={{ marginBottom: 0 }}
                text={organizationName}
              />
            </Col>
          )}

          <Col span={24}>
            <Text text={accountName} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
